import { InvoiceStatus, invoiceStatusValues } from "@/types";

export const getNotificationMessage = (status: InvoiceStatus, t: (key: string) => string): string | undefined => {
    switch (status) {
        case invoiceStatusValues.Rejected:
            return t("notifications.message.rejected");
        case invoiceStatusValues.Approved:
            return t("notifications.message.approved");
        default:
            return undefined;
    }
};

/** Parses API datetimes; timezone-less values are treated as UTC. */
const parseNotificationCreatedAt = (createdAt: string): Date => {
    const hasTimezone = /([zZ]|[+-]\d{2}:?\d{2})$/.test(createdAt);
    return new Date(hasTimezone ? createdAt : `${createdAt}Z`);
};

export const formatNotificationDateTime = (createdAt: string | null | undefined): string => {
    if (!createdAt) {
        return "";
    }

    const date = parseNotificationCreatedAt(createdAt);
    if (Number.isNaN(date.getTime())) {
        return "";
    }

    return date.toLocaleString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
    });
};
